import { useState, useEffect, useCallback, useMemo } from "react";
import { forceRound } from "helpers/function";

export const usePagination = (rapportAuto, searchFunction) => {
  const [numberPerPage, setNumberPerPage] = useState(5);
  const [activeNumberPage, setActiveNumberPage] = useState(1);
  const [showList, setShowList] = useState([]);
  const [currentSearchValue, setCurrentSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const currentData = currentSearchValue ? filteredData : rapportAuto;
  const numberPage = useMemo(() => {
    return forceRound(currentData.length / numberPerPage);
  }, [currentData.length, numberPerPage]);

  const pages = useMemo(() => {
    const pageArray = [];
    for (let i = 0; i < numberPage; i++) {
      pageArray[i] = i;
    }
    return pageArray;
  }, [numberPage]);

  const getEndByPosition = useCallback(
    (position) => {
      let end = numberPerPage;
      for (let i = 1; i < position; i++) {
        end = end + numberPerPage;
      }
      return end;
    },
    [numberPerPage]
  );

  useEffect(() => {
    const dataToUse = currentSearchValue ? filteredData : rapportAuto;

    if (dataToUse.length > 0) {
      const startIndex = getEndByPosition(activeNumberPage) - numberPerPage;
      const endIndex = getEndByPosition(activeNumberPage);
      setShowList(dataToUse.slice(startIndex, endIndex));
    } else {
      setShowList([]);
    }
  }, [
    rapportAuto,
    filteredData,
    activeNumberPage,
    numberPerPage,
    currentSearchValue,
    getEndByPosition,
  ]);

  const onChangeNumberPerPage = useCallback((e) => {
    const newPerPage = parseInt(e.target.value);
    setActiveNumberPage(1);
    setNumberPerPage(newPerPage);
  }, []);

  const onClickPage = useCallback((e, page) => {
    e.preventDefault();
    setActiveNumberPage(page);
  }, []);

  const onClickNextPage = useCallback(
    (e) => {
      e.preventDefault();
      if (activeNumberPage < numberPage) {
        setActiveNumberPage(activeNumberPage + 1);
      }
    },
    [activeNumberPage, numberPage]
  );

  const onClickPreviousPage = useCallback(
    (e) => {
      e.preventDefault();
      if (activeNumberPage > 1) {
        setActiveNumberPage(activeNumberPage - 1);
      }
    },
    [activeNumberPage]
  );

  const searchWithPagination = useCallback(
    (searchValue) => {
      setCurrentSearchValue(searchValue);
      setActiveNumberPage(1);

      if (searchValue && searchValue.trim()) {
        const filtered = searchFunction(searchValue);
        setFilteredData(filtered);
      } else {
        setFilteredData([]);
      }
    },
    [searchFunction]
  );

  return {
    showList,
    numberPerPage,
    activeNumberPage,
    numberPage,
    pages,
    onChangeNumberPerPage,
    onClickPage,
    onClickNextPage,
    onClickPreviousPage,
    searchWithPagination,
    getEndByPosition,
  };
};
